export const ECO_BIO_REGION_RESTRICTED_OPTION_NO_ID = 1
export const ECO_BIO_REGION_RESTRICTED_OPTION_B3A_ID = 2
export const ECO_BIO_REGION_RESTRICTED_OPTION_B3B_ID = 3

export const ecoBioRegionRestricted = [
  { id: ECO_BIO_REGION_RESTRICTED_OPTION_NO_ID, name: 'no' },
  { id: ECO_BIO_REGION_RESTRICTED_OPTION_B3A_ID, name: 'b3a' },
  { id: ECO_BIO_REGION_RESTRICTED_OPTION_B3B_ID, name: 'b3b' }
]

